import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import useCurrentAccessory from "@/services/product/hooks/use-current-accessory.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";

export default function AccessoryDetails() {
    const t = useTranslations();

    const accessory = useCurrentAccessory();
    if (!accessory) return null;

    return (
        <>
            <DefinitionTerm>{t("light_altering_device")}</DefinitionTerm>
            <DefinitionDescription>{accessory.title}</DefinitionDescription>
        </>
    );
}
